/* eslint-disable */
export default {
  recentActivities: 'Recent Activities',
  text: 'Text',
  fax: 'Fax',
  voicemail: 'Voicemail',
  call: 'Call',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
